import { EDITABLE_TAXONOMIES } from '@common/constants/editable-taxonomies.constants'
import { READ_ONLY_TAXONOMIES } from '@common/constants/read-only-taxonomies.constants'
import { normalizeTaxonomy } from '@common/utils/taxonomy-normalizer.util'

export const isTaxonomyEditable = (resourceSlug: string): boolean =>
  EDITABLE_TAXONOMIES.has(normalizeTaxonomy(resourceSlug))

export const isReadOnlyTaxonomy = (resourceSlug: string): boolean =>
  READ_ONLY_TAXONOMIES.has(normalizeTaxonomy(resourceSlug))
